import { AppUsers } from "./AppUsers";
import { DataSafe } from "@/models/DataSafe"


interface StringKeyArray {
    [index: string]: number;
}

export class SymptomData{
    static attributePrefix = "Symptoms";
    static attributePrefixDe = "Symptome";

//    static getDeName(engname: String){
//        let myAttributeNames = DataSafe.myAttributes();
//        let myAttributeNamesDe = DataSafe.myAttributesDe();
//        /* @ts-ignore */
//        //console.log(myAttributeNames.indexOf(this.attributePrefix+'_'+engname))
//        /* @ts-ignore */
//        return myAttributeNamesDe[myAttributeNames.indexOf(this.attributePrefix+'_'+engname)].replace(SymptomData.attributePrefixDe+"_","");
//    }
//
//    static getMyAttributeNumbers(){
//        let myAttributeNames = DataSafe.myAttributes();
//        //console.log(myAttributeNames);
//        let attributes = {};
//        myAttributeNames.forEach(function(value,index){
//            if(value.includes(SymptomData.attributePrefix)){
//                let key = value.replace(SymptomData.attributePrefix+"_","");
//               // console.log(index);
//                /* @ts-ignore */
//                attributes[key.toString()]=index;
//            }
//        });
//
//        // see DataSafe !!!
//
//        return attributes;
//    }
//
//    static getSetUpArray(){
//        let myAttributeNames = DataSafe.myAttributes();
//        //console.log(myAttributeNames);
//        let attributes = {};
//        myAttributeNames.forEach(function(value,index){
//            if(value.includes(SymptomData.attributePrefix)){
//                let key = value.replace(SymptomData.attributePrefix+"_","");
//               // console.log(index);
//                /* @ts-ignore */
//                attributes[key.toString()]=false;
//            }
//        });
//
//        // see DataSafe !!!
//
//        return attributes;
//    }
//
//
//        /* @ts-ignore */
//        static async insertOrUpdateToDate(vals,ValueDate){
//    
//            await AppUsers.getMyUser().then((user) => {
//                let vars = {};
//                let myAttributes = SymptomData.getMyAttributeNumbers();
//                let defaultKeys = Object.keys(myAttributes);
//                for(var i = 0; i < defaultKeys.length; i++){
//                    let helpkey = defaultKeys[i];
//    
//                    if(typeof vals[helpkey] != 'undefined'){
//                        /* @ts-ignore */
//                        vars[myAttributes[helpkey]] = vals[helpkey];
//                    }
//                }
//    
//                DataSafe.insertOrUpdateToDate(user.sysId, vars, ValueDate );
//            });
//        }
//
//
//    static async getMyDayValues(ShowDate: Date){
//        return await AppUsers.getMyUser().then((user) => {
//            //console.log(Object.values(ProfileData.getMyAttributeNumbers()));
//            let myAttributes = SymptomData.getMyAttributeNumbers();
//            return DataSafe.getDayValuesToAttributes(user.sysId, Object.values(myAttributes), ShowDate ).then((res) => {
//                let defaultRet = SymptomData.getSetUpArray();
//                let defaultKeys = Object.keys(defaultRet);
//                for(var i = 0; i < defaultKeys.length; i++){
//                    let helpkey = defaultKeys[i];
//                    //console.log(myAttributes)
//                    /* @ts-ignore */
//                    if(typeof res.get(myAttributes[helpkey]) != 'undefined'){
//                        //console.log(res.get(myAttributes[helpkey]).value)
//                        /* @ts-ignore */
//                        defaultRet[helpkey] = res.get(myAttributes[helpkey]).value;
//                    }
//                }
//                //console.log(defaultRet)
//                return defaultRet;
//            });
//        });
//    }
}